import React from "react";
import { PluginManager } from "../plugins/PluginManager";
import type { MapAdapter } from "./MapAdapter";
import type { MapType } from "../types/MapTypes";

export interface MapContextValue {
  engine: MapAdapter | null;
  pluginManager: PluginManager | null;
  mapType: MapType;
  mapInstance: any;
}

export const MapContext = React.createContext<MapContextValue>({
  engine: null,
  pluginManager: null,
  mapType: "maplibre",
  mapInstance: null,
});

export const useMapContext = () => React.useContext(MapContext);
